export default [
  {
    path: '/order/:clazz_id(\\w+)/confirm',
    name: 'orderconfirm',
    component: () => import('@/views/order/orderconfirm.vue')
  },
  {
    path: '/race_order/:race_id(\\w+)/confirm',
    name: 'race_orderconfirm',
    component: () => import('@/views/order/race_orderconfirm.vue')
  },
  {
    path: '/order/:order_no(\\w+)/detail',
    name: 'orderdetail',
    component: () => import('@/views/order/orderdetail.vue')
  }
]
